export const initialState = {
  isAuthorized: false,
  user: {}
};
